<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :title="$t('Modify') + ' ' + $t('a.technician')"/>
      </div>
      <b-card class="mt-2 mb-4 shadow-sm">
        <b-form @submit.stop.prevent="onSubmit">

          <div class="mb-3">
            <b-form-checkbox
              id="isManager-input"
              v-model="form.isManager.value"
              :state="form.isManager.state"
            >
              <div class="bold-text"> {{$t('isManager-cb-label')}}</div>
            </b-form-checkbox>
          </div>

      <b-form-group
          id="firstName-input"
          :label="$t('technician.FirstName')+'*'"
          label-for="firstName-input"
          class="bold-label"
          :invalid-feedback="form.firstName.invalidFeedback"
          :state="form.firstName.state"
      >
        <b-form-input
            id="firstName-input"
            v-model="form.firstName.value"
            type="text"
            maxlength="250"
            :state="form.firstName.state"
            required
        ></b-form-input>
      </b-form-group>

      <b-form-group
          id="lastName-input"
          :label="$t('technician.LastName')+'*'"
          label-for="lastName-input"
          class="bold-label"
          :invalid-feedback="form.lastName.invalidFeedback"
          :state="form.lastName.state"
      >
        <b-form-input
            id="lastName-input"
            v-model="form.lastName.value"
            type="text"
            maxlength="250"
            :state="form.lastName.state"
            required
        ></b-form-input>
      </b-form-group>

          <b-form-group
              id="username-input"
              :label="$t('technician.Email')+'*'"
              label-for="username-input"
              class="bold-label"
              :invalid-feedback="form.username.invalidFeedback"
              :state="form.username.state"
          >
            <b-form-input
                id="username-input"
                v-model="form.username.value"
                type="email"
                maxlength="250"
                :state="form.username.state"
                required
            ></b-form-input>
          </b-form-group>

          <b-form-group
              id="phoneNumber-input"
              :label="$t('technician.PhoneNumber')+'*'"
              label-for="phoneNumber-input"
              class="bold-label"
              :invalid-feedback="form.phoneNumber.invalidFeedback"
              :state="form.phoneNumber.state"
          >
            <b-form-input
                id="phoneNumber-input"
                v-model="form.phoneNumber.value"
                type="text"
                maxlength="250"
                :state="form.phoneNumber.state"
                required
            ></b-form-input>
          </b-form-group>

          <b-form-group
              id="googleAgendaLink-input"
              :label="$t('technician.GoogleAgendaLink')+'*'"
              label-for="googleAgendaLink-input"
              class="bold-label"
              :invalid-feedback="form.googleAgendaLink.invalidFeedback"
              :state="form.googleAgendaLink.state"
          >
            <b-form-input
                id="googleAgendaLink-input"
                :placeholder="$t('google.calendar.id')"
                v-model="form.googleAgendaLink.value"
                type="text"
                maxlength="250"
                :state="form.googleAgendaLink.state"
                required
            ></b-form-input>
          </b-form-group>

          <PasswordCreationField
              :isEdit="true"
              @passwordInfos="getPasswordInfos"
          ></PasswordCreationField>

          <div class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
          </div>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/b122/BackArrow";
import DateField from "../../components/b122/DateField";
import PasswordCreationField from "@/components/b122/PasswordCreationField";
export default {

  name: 'TechnicianEdit',

  components: {
    BackArrow,
    DateField,
    PasswordCreationField
  },

  data() {
    return {

      technicianId: this.$route.params.technicianId,
      form: {
        isManager:
          {
            state: null,
            invalidFeedback: null,
            value: false
          },
        password:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        username:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        googleAgendaLink:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        firstName:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        lastName:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        phoneNumber:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },

      }
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.fetchTechnician()
    },

    fetchTechnician() {
      api
          .get(`/technician/${this.technicianId}`)
          .then(response => {
            this.technician = response.data
            this.setInitialValues()
          })
    },


    setInitialValues() {
      this.form.isManager.value = this.technician.isManager
      this.form.username.value = this.technician.username
      this.form.googleAgendaLink.value = this.technician.googleAgendaLink
      this.form.firstName.value = this.technician.firstName
      this.form.lastName.value = this.technician.lastName
      this.form.phoneNumber.value = this.technician.phoneNumber
    },

    onSubmit() {
      let data = new FormData()
      data.append('isManager', this.form.isManager.value)
      data.append('password', this.form.password.value)
      data.append('username', this.form.username.value)
      data.append('googleAgendaLink', this.form.googleAgendaLink.value)
      data.append('firstName', this.form.firstName.value)
      data.append('lastName', this.form.lastName.value)
      data.append('phoneNumber', this.form.phoneNumber.value)

      api({
        method: 'POST',
        url: `/technician/${this.technician.id}`,
        data: data
      })
          .then((response) => {
            this.$router.push({
              name: 'TechnicianShow',
              params: {
                technicianId: this.technician.id
              }
            }, () => {
              this.$nextTick(() => {
                this.successToast(this.form.firstName.value + " " + this.form.lastName.value)
              })
            })
          })
          .catch((error) => {
            if (error.response.status === 418) {
              const invalidField = error.response.data.invalidField
              this.form[invalidField]["state"] = false
              this.form[invalidField]["invalidFeedback"] = error.response.data.message
            }
          });
    },

    successToast(technicianName) {
      this.$bvToast.toast(this.$i18n.t('Technician') + ' "' + technicianName + '" ' + this.$i18n.t('modify'), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    getPasswordInfos(state, invalidFeedBack, value) {
      this.form.password.state = state;
      this.form.password.invalidFeedback = invalidFeedBack;
      this.form.password.value = value;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/technician/TechnicianEdit.vue